import { useMantineColorScheme } from '@mantine/core';
import { useEffect, useState } from 'react';
import styles from './ThinkingLoader.module.css';

export function ThinkingLoader() {
    const { colorScheme } = useMantineColorScheme();
    const [dots, setDots] = useState('');

    useEffect(() => {
        const interval = setInterval(() => {
            setDots(prev => (prev.length >= 3 ? '' : prev + '.'));
        }, 500);

        return () => clearInterval(interval);
    }, []);

    const thinkingText = 'Thinking';

    return (
        <div className={`${styles.thinkingContainer} ${colorScheme === 'dark' ? styles.dark : styles.light}`}>
            <span className={styles.thinkingText}>
                {thinkingText.split('').map((char, index) => (
                    <span
                        key={index}
                        className={styles.letter}
                        style={{
                            animationDelay: `${index * 0.1}s`
                        }}
                    >
                        {char}
                    </span>
                ))}
            </span>
            <span className={styles.dots}>{dots}</span>
        </div>
    );
}

